import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";
import {
  SERVICE_QUEUE_DIALOG_MESSAGES,
  ServiceQueueDialogMessages,
} from "./service-queue-dialog.messages";
import {
  SERVICE_QUEUE_REQUEST_MESSAGES,
  ServiceQueueRequestMessages,
} from "./service-queue-request.messages";
import {
  SERVICE_QUEUE_TABLE_MESSAGES,
  ServiceQueueTableMessages,
} from "./service-queue-table.messages";

export type ServiceQueueFormMessages = SidebarMessages &
  ActionButtonMessages &
  PopoverMessages &
  ServiceQueueRequestMessages &
  TableColumnsMessages &
  ServiceQueueTableMessages &
  ServiceQueueDialogMessages & {
    pageTitle: string;
    breadCrumbTitle: string;
    createPageTitle: string;
    updatePageTitle: string;
    viewPageTitle: string;
    serviceQueueTableTitle: string;
    addServiceQueueButton: string;
    serviceQueueCardTitle: string;
    usersCardTitle: string;

    errorRequiredName: string;
    errorRequiredRoutingType: string;
    errorRequiredSla: string;
    errorInvalidSla: string;

    nameLabel: string;
    namePlaceholder: string;
    activeLabel: string;
    routingTypeLabel: string;
    slaLabel: string;
    slaHelperText: string;
    addUserLabel: string;
    userNotFound: string;
    noAttendantsRegistered: string;
    userAlreadyAdded: string;
    noUsersAddedMessage: string;
    addUserButton: string;
  };

export const SERVICE_QUEUE_FORM_MESSAGES: ServiceQueueFormMessages = {
  pageTitle: "Filas de Atendimento",
  createPageTitle: "Criar Fila de Atendimento",
  updatePageTitle: "Editar Fila de Atendimento",
  viewPageTitle: "Visualizar Fila de Atendimento",
  serviceQueueTableTitle: "Listagem de Filas de Atendimento",
  breadCrumbTitle: "Filas de Atendimento",
  addServiceQueueButton: "Nova Fila +",
  serviceQueueCardTitle: "Informações da Fila",
  usersCardTitle: "Usuários da Fila",

  errorRequiredName: "Por favor, insira o nome da fila",
  errorRequiredRoutingType: "Por favor, selecione o tipo de distribuição",
  errorRequiredSla: "Por favor, informe o SLA da fila",
  errorInvalidSla: "Informe o SLA em minutos, entre 1 e 1440",

  nameLabel: "Nome",
  namePlaceholder: "Ex: Fila Comercial",
  activeLabel: "Ativa",
  routingTypeLabel: "Tipo de distribuição",
  slaLabel: "SLA (minutos)",
  slaHelperText: "Tempo alvo de resposta usado no dashboard operacional",
  addUserLabel: "Adicionar usuário",
  userNotFound: "Nenhum usuário encontrado",
  noAttendantsRegistered: "Não há atendentes registrados",
  userAlreadyAdded: "Usuário já adicionado à fila",
  noUsersAddedMessage: "Nenhum usuário adicionado",
  addUserButton: "Adicionar",

  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...POPOVER_MESSAGES,
  ...SERVICE_QUEUE_REQUEST_MESSAGES,
  ...TABLE_COLUMNS_MESSAGES,
  ...SERVICE_QUEUE_TABLE_MESSAGES,
  ...SERVICE_QUEUE_DIALOG_MESSAGES,
};

export default SERVICE_QUEUE_FORM_MESSAGES;
